import React from 'react';
import styled from 'styled-components';
import { Box, Heading } from '@99designs/emu';
import { Starburst } from './Starburst';

const StyledBox = styled(Box)`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 100%;
`;

export function LoadingSection() {
    return (
        <StyledBox>
            <Starburst />
            <Heading appearanceLevel={2} accessibilityLevel={1}>
                {__('Getting your recommendations...')}
            </Heading>
        </StyledBox>
    );
}
